import { usePlatformUpdate } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'
import * as yup from 'yup'

export const withdrawAgreementSchema = yup.object({
  withdrawalReason: yup.string().optional(),
  notifyRecipients: yup.boolean().optional(),
  iDs: yup.array(yup.string()).required(),
})

export type TWithdrawAgreement = yup.InferType<typeof withdrawAgreementSchema>

export const useWithdrawAgreement = () => {
  const path: string = '/api/User/Document/Withdraw'

  const [withdrawAgreement, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    TWithdrawAgreement,
    IDocuments
  >({
    path: path,
    method: 'PATCH',
    headers: {},
    errorMessage: 'Failed to withdraw the agreement',
    successMessage: 'Agreement successfully withdrawn',
  })

  return { withdrawAgreement, returnData, isLoading, isSuccess, isError }
}
